import classnames from 'classnames';
import React from 'react';
import { Link } from 'react-router-dom';

import { Image } from 'src/app/components/Image/Image';
import { OverlayNewVideo } from 'src/app/components/Overlay/OverlayNewVideo';
import { ProgramItemOverlay } from 'src/app/components/Program/ProgramItemOverlay';
import { ResponsiveContainer } from 'src/app/components/ResponsiveContainer/ResponsiveContainer';
import { PARAMS, PROGRAM_VIEW } from 'src/app/constants/route';
import { withStyles } from 'src/app/helpers/styles';
import { ProgramWithOverlay } from 'src/app/models/program';

interface MyProps extends ProgramWithOverlay {
  thumbnail: string;
  className?: string;
  hasNewVideo?: boolean;
  railAnalytics?: string;
}

@withStyles(require('./ProgramItem.scss'))
export class ProgramItem extends React.Component<MyProps> {
  render(): JSX.Element {
    const { className, hasNewVideo, name, slug, thumbnail, railAnalytics } = this.props;
    const programPath = PROGRAM_VIEW.replace(PARAMS.SLUG, slug);
    return (
      <div className={classnames('d-block position-relative radius program-item ', className)}>
        <Link to={{ pathname: programPath, search: '?sortBy=NEWEST', state: { railAnalytics } }} className="overflow-hidden">
          <ResponsiveContainer modifier="3-4" className="radius">
            <Image className="w-100 program-item__thumbnail-image" alt={name} src={thumbnail} />
          </ResponsiveContainer>
          {hasNewVideo && <OverlayNewVideo />}
        </Link>
        <ProgramItemOverlay
          {...this.props as ProgramWithOverlay}
          programPath={programPath}
          railAnalytics={railAnalytics}
          className="program-item__overlay"
        />
      </div>
    );
  }
}
